/**
 * @file 文档搜索页 搜索框
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, { FC, useCallback, useState } from 'react';
import { Input } from 'antd';
import { SearchProps } from 'antd/lib/input';

const Search = Input.Search;

const SearchInput: FC<SearchProps> = (props) => {
    const [value, setValue] = useState(() => {
        return props.value !== undefined ? props.value : props.defaultValue;
    });

    const handleOnChange = useCallback<NonNullable<SearchProps['onChange']>>((event) => {
        const value = event.target.value;
        setValue(value);
    }, [setValue]);

    const propsOnSearch = props.onSearch;
    const handleOnSearch = useCallback(() => {
        propsOnSearch && propsOnSearch('' + value);
    }, [propsOnSearch, value]);

    return (
        <Search
            {...props}
            value={value}
            onChange={handleOnChange}

            onSearch={handleOnSearch}
            onPressEnter={handleOnSearch}
            onBlur={handleOnSearch}
        />
    );
};

export default SearchInput;
